/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';

// misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { FORM_CONFIGURATION_VIBER_INTEGRATION_PATH } from '../../../../constants/deploymentFormPaths';

const BotDeploymentsViberStrategyGeneralForm = ({ form, hasEditAccess }) => {
  const { t } = useTranslation();
  const { formProps } = useTheme();
  return (
    <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
      <Col xs={formProps.mainColSpan}>
        <Row>
          <Col flex="auto">
            <Typography.Text>
              {t('Application Settings')}
            </Typography.Text>
            <Typography.Paragraph className="fs-sm" type="secondary">
              {t('Enter the Viber Authentication Token.')}
            </Typography.Paragraph>
          </Col>
        </Row>
      </Col>

      <Col xs={formProps.secondaryColSpan}>
        <Form.Item
          label={t('Authentication Token')}
          name={[...FORM_CONFIGURATION_VIBER_INTEGRATION_PATH, 'authToken']}
          rules={[{
            required: true,
            message: t('Please input authentication token')
          }]}
        >
          {
            hasEditAccess
              ? <Input placeholder={t('Enter Authentication Token')} />
              : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_VIBER_INTEGRATION_PATH, 'authToken'])}</Typography.Text>
          }
        </Form.Item>
      </Col>
    </Row>
  );
};

BotDeploymentsViberStrategyGeneralForm.propTypes = {
  form: PropTypes.object,
  hasEditAccess: PropTypes.bool
};

export default BotDeploymentsViberStrategyGeneralForm;
